export default __webpack_public_path__ + "static/media/calender.a1dbaf29.svg";